import { DialogClientService } from '@rightship-tech/common-ui/services/basic/dialog-client.service';
import { autoinject } from 'aurelia-dependency-injection';

@autoinject
export class ChangeInspectionCompanyConfirmDialog {

    public oldInspectionCompany: string;
    public newInspectionCompany: string;
    onProceed: () => void;

    constructor(private dialogClientService: DialogClientService) {
    }

    activate(params: {  oldInspectionCompany: string, newInspectionCompany: string, onProceed: () => Promise<void> }) 
    {
        this.oldInspectionCompany = params.oldInspectionCompany;
        this.newInspectionCompany = params.newInspectionCompany;
        this.onProceed = params.onProceed;
    }   

    //Save
    async save() {
        await this.close();
        if(this.onProceed) await this.onProceed();
    }

    //Close dialog
    async close() {
        await this.dialogClientService.hide(true, "default", false);
    }
}